export enum ProductionTimeRange {
  THIS_MONTH = 'this_month',
  LAST_MONTH = 'last_month',
  THIS_YEAR = 'this_year',
  LAST_YEAR = 'last_year',
  ALL = 'all',
}

export function getProductionTimeRangeLabel(timeRange: ProductionTimeRange): string {
  switch (timeRange) {
    case ProductionTimeRange.THIS_MONTH:
      return 'Este mês';
    case ProductionTimeRange.LAST_MONTH:
      return 'Mês passado';
    case ProductionTimeRange.THIS_YEAR:
      return 'Este ano';
    case ProductionTimeRange.LAST_YEAR:
      return 'Ano passado';
    case ProductionTimeRange.ALL:
      return 'Desde o início';
  }
}
